module.exports = "https://www.gc-pro.gnp.com.mx/2a096ac5422b39d2d3650b9e42fdbe0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/auto4.png
// module id = 1801
// module chunks = 0